<template>
  <div class="home">
    <bookings />
  </div>
</template>

<script>
import Bookings from "../components/views/Bookings";
import {mapActions} from 'vuex';
export default {
  name: 'home',
  components: {Bookings},
  async mounted() {
    await this.setCumulative(new Date());
    await this.setBookings(new Date());
    await this.setScripts();
    await this.setRepeats();
    await this.setUpcomingRepeats();
    await this.setCustomers();
    await this.setPeriods();
    await this.setTechnicians();
    await this.setServices();
    await this.setCategories();
    await this.setAccounts();
  },
  methods: {
    ...mapActions("bookings", ["setBookings", "setCumulative"]),
    ...mapActions("repeats", ["setRepeats", "setUpcomingRepeats"]),
    ...mapActions("customers", ["setCustomers"]),
    ...mapActions("technicians", ["setTechnicians"]),
    ...mapActions("periods", ["setPeriods"]),
    ...mapActions("scripts", ["setScripts"]),
    ...mapActions("xero", ["setServices", "setCategories", "setAccounts"]),
  }
}
</script>
